import React from 'react';

export default function LisaPage() {
  return (
    <iframe
      src="/lisa.html"
      title="Lisa"
      style={{
        border: 0,
        display: 'block',
        height: '100vh',
        width: '100%',
      }}
    />
  );
}
